    // live env path
export const backendurl = "https://myappserver13.onrender.com";

    // local env path
// export const backendurl = "http://localhost:5003";

